export enum NotificationAdminSettingsEvent {
    Navigate = 'NotificationAdminSettings.Navigate',
    AddUserProfile = 'NotificationAdminSettings.AddUserProfile',
    EditDefaultProfile = 'NotificationAdminSettings.EditDefaultProfile',
}
